module.exports = __webpack_public_path__ + "img/Boli-USA.2f3dab8b.jpg";